export const getCompanyStatus = (companies) => {
  let status = "Completed";
  for (let i = 0; i < companies?.length; i++) {
    if (companies?.[i]?.completed && !companies?.[i]?.printed) {
      status = "Action needed";
      break;
    }
    if (!companies?.[i]?.completed) {
      status = "inProgress";
    }
  }
  return status;
};
